import React, { Component } from 'react'
import styled from 'styled-components'
import Helmet from 'react-helmet'
import LayoutContainer from '../components/LayoutContainer'
import Card from '../components/Card/Card'
import CardBody from '../components/Card/CardBody'
import AnchorPills from '../components/NavPills/AnchorPills'
import { primaryColor } from '../assets/jss/material-kit-pro-react'

class FeesTemplate extends Component {
  getActiveTab(tabs) {
    const path = this.props.location.pathname
    let activeTab
    tabs.forEach(tab => {
      if (path === tab.tabLink) {
        activeTab = tab.i
      }
    })
    return activeTab
  }
  render() {
    const page = this.props.data.page
    const tabs = this.props.data.settings.edges[0].node.frontmatter.feesOrder.map(
      (tab, i) => ({
        tabButton: tab.title,
        tabLink: tab.link,
        i,
      })
    )

    return (
      <LayoutContainer background="linear-gradient(147deg, #efefef, #ffffff)">
        <Helmet title={page.frontmatter.title} />
        <DocumentationTitle>{page.frontmatter.title}</DocumentationTitle>
        <DocumentationContainer>
          <DocumentationNav>
            <AnchorPills
              leftAlign
              color="primary"
              horizontal
              active={this.getActiveTab(tabs)}
              tabs={tabs}
            />
          </DocumentationNav>
          <DocumentationCard raised>
            <DocumentationCardBody>
              <InnerContainer dangerouslySetInnerHTML={{ __html: page.html }} />
            </DocumentationCardBody>
          </DocumentationCard>
        </DocumentationContainer>
      </LayoutContainer>
    )
  }
}

export default FeesTemplate

const DocumentationCardBody = styled(CardBody)`
  @media screen and (max-width: 768px) {
    max-width: 100vw;
  }
`

const InnerContainer = styled.p`
  @media screen and (max-width: 768px) {
    width: 100%;
    div {
      max-width: 100vw;
      overflow-x: auto;
    }
  }

  a {
    color: ${primaryColor};
    text-decoration: underline;
  }

  table {
    display: inline-table;
    margin: 1rem;
    min-width: 250px;
    border-spacing: 0;
    max-width: 90vw;
    border: 1px solid rgba(33, 36, 87, 0.1);

    @media screen and (max-width: 768px) {
      margin: 1rem 0;
    }

    img {
      display: inline;
      width: 1.5rem;
      margin-right: 0.5rem;
    }

    td,
    th {
      padding: 0.75rem 1rem;
    }

    thead {
      color: white;

      p {
        margin: 0;
      }

      tr:nth-child(2) th {
        background: #141534;
        padding: 0.25rem 1rem;
        position: unset;
        top: initial;
        z-index: -1;

        text-align: center;
      }

      th {
        box-shadow: 0 3px 5px rgba(33, 36, 87, 0.24);
        background: ${primaryColor};
        @media screen and (min-width: 768px) {
          position: sticky;
          top: 70px;
        }

        &[colspan='2'] {
          text-align: center;
        }
      }
    }

    td {
      border-top: 1px solid rgba(33, 36, 87, 0.2);
    }

    tr {
      &:nth-child(even) {
        background: rgba(33, 36, 87, 0.1);
      }
    }
  }
`

const DocumentationTitle = styled.h2`
  margin-left: ${p => p.theme.col(4)};
  margin-top: ${p => p.theme.col()};

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 0 ${p => p.theme.col()};
    margin-top: 100px;
  }
`

const DocumentationNav = styled.div`
  height: 100%;
  > div {
    @media screen and (max-width: 768px) {
      padding: 0 ${p => p.theme.col()};
    }
    @media screen and (min-width: 767px) {
      padding-top: ${p => p.theme.col()};
      position: sticky;
      top: 50px;
      height: 200px;
    }
  }
`

const DocumentationCard = styled(Card)`
  padding: ${p => p.theme.col()} ${p => p.theme.col()} ${p => p.theme.col(2)}
    ${p => p.theme.col(2)};

  @media screen and (max-width: 768px) {
    padding: ${p => p.theme.col()} 0;
  }
`

const DocumentationContainer = styled.div`
  padding: ${p => p.theme.col()};
  padding-top: 2rem;
  display: grid;
  grid-template-columns: ${p => p.theme.col(2.5)} 1fr;
  grid-gap: ${p => p.theme.col(0.5)};

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 1rem 0;
  }
`

export const FeesQuery = graphql`
  query FeesQuery($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      html
      fields {
        slug
      }
      frontmatter {
        title
        pdf {
          publicURL
        }
      }
    }
    docs: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "fees-template" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
    settings: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "documentation-settings" } } }
    ) {
      edges {
        node {
          frontmatter {
            feesOrder {
              title
              link
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/fees.jsx